import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import { COURSE_MODE } from '@/courses/enums/course-edition.enum';
import { ContentType } from '@/content/types/content.types';
import { Section } from '@/courses/models/section.model';
import { SectionProvider } from '@/sections/providers/section.provider';
import { SECTION_OPTIONS_ROOT_TEMPLATES } from '@/content/values/sections';
import { SectionsProvider } from '@/content/providers/sections.provider';
import { EdSectionOptions } from '@/content/models/ed-section-options.model';

@Component({
  name: 'ed-fun-sections',
  components: {
    EdContentSidebarSection: () => import(/* EdContentSidebarSection */'@/sections/components/ed-content-sidebar-section/ed-content-sidebar-section.component.vue'),
  }
})
export default class EdFunSectionsComponent extends Vue {

  @Prop({ default: null }) readonly contentId: number;
  @Prop({ default: null }) readonly classId: number;
  @Prop({ default: '' }) readonly componentName: string;
  @Prop({ default: COURSE_MODE.VIEWER }) readonly mode: COURSE_MODE;
  @Prop({ default: 'SUBJECT' }) readonly contentType: ContentType;
  @Prop({ default: () => [] }) readonly sections: Section[];
  @Prop({ default: false }) readonly loading: boolean;
  @Prop({ default: false }) readonly loaded: boolean;
  @Prop({ default: null }) readonly options: EdSectionOptions;
  @Prop({ default: false }) readonly isProject: boolean;

  get isShownWithoutContent(): boolean {
    if (this.mode === COURSE_MODE.VIEWER) {
      return this.funSections.length > 0;
    }
    return true;
  }

  get fun(): Section {
    return this.sections.find(
      s => s.fixedSection === 'FUN'
    );
  }

  get funSections() {
    return this.fun ? this.fun.sections : [];
  }

  get lessonCounter() {
    return SectionProvider.getLessonCounter(this.funSections || []);
  }

  get menuAddOptions() {
    if(this.contentType === 'TEMPLATE') {
      return SectionsProvider.getCreateObjMenu([...SECTION_OPTIONS_ROOT_TEMPLATES], this.$i18n);
    }
    return [];
  }

  goToAddFunSection(minDate: string = null, isCreatingLesson = false) {
    SectionProvider.openLessonCreator(
      this.contentId,
      this.classId,
      this.fun,
      minDate,
      isCreatingLesson,
      'FUN'
    );
  }

}